export const months = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'];

export const days = ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'];
